import LangSwitch from './LangSwitch';
import './style/lang-switch.less';

export default LangSwitch;
